import { jsx as _jsx } from "react/jsx-runtime";
import { Tag, Tooltip } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import { Sentry, SentryTeam } from 'app/utils/sentry';
import { conversationStatusAttributes } from 'utils/conversation/conversationAttributes';
import { useShortHumanReadableTimer } from 'utils/useShortHumanReadableTimer';
import { useConversationRow } from '../../../utils/useConversationRow';
/** Represents the content of the status cell in the conversations table. */
export const ConversationsTableStatus = () => {
    const { conversationAndRequester: { conversation: { status, pending_expiration_at }, }, } = useConversationRow();
    const followUpTime = useShortHumanReadableTimer(pending_expiration_at);
    // NOTE: It appears that sometimes the status can be something that we
    // currently have recorded in the API types. While this is being investigated,
    // this should prevent the view from crashing and gracefully present a
    // fallback.
    if (typeof conversationStatusAttributes[status] === 'undefined') {
        Sentry.captureMessage(`Unknown conversation status '${status}'`, {
            level: 'warning',
            tags: { team: SentryTeam.Conversations },
        });
        return _jsx(Tag, Object.assign({ color: colors.neutral['500'] }, { children: "Unknown" }));
    }
    const { label, color } = conversationStatusAttributes[status];
    const isPending = status === 'awaitingpending' || status === 'pending';
    const statusLabel = isPending ? 'Follow up' : label;
    return (_jsx(Tooltip, Object.assign({ dark: true, content: `Follow up ${followUpTime}`, disabled: !pending_expiration_at }, { children: _jsx(Tag, Object.assign({ color: color }, { children: statusLabel })) })));
};
